export default "__VITE_ASSET__CAIz6g12__"